module.exports = __webpack_public_path__ + "img/errimg.73f5ff20.svg";